var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15562 2.82187L5 0.625L3.84438 2.82187C3.76274 2.98241 3.64457 3.12156 3.49937 3.22813C3.35347 3.33524 3.18464 3.40692 3.00625 3.4375L0.625 3.90438L2.2875 5.8925C2.51486 6.14168 2.62214 6.47767 2.58125 6.8125L2.265 9.375L4.4575 8.3125C4.62664 8.23058 4.81207 8.18786 5 8.1875C5.17632 8.18804 5.34994 8.23091 5.50625 8.3125L7.75 9.30938L7.43375 6.7775C7.39378 6.44341 7.50124 6.10847 7.72812 5.86L9.375 3.90438L6.99375 3.4375C6.81514 3.40701 6.64608 3.33533 6.5 3.22813C6.35503 3.12149 6.23709 2.98235 6.15562 2.82187Z",
    fill: "#F04400",
    stroke: "#F04400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.888ebe76e8d5753b9ace13f07c31ebf9.svg";
export { ForwardRef as ReactComponent };